module.exports = __webpack_public_path__ + "static/media/hp-login-banner-mobile-@2x.59032973.jpg";